import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import { useGetTaskByIdAndType } from "@coworker/apprestructured/src/tasks/hooks/useGetTaskByIdAndType";
import { TaskData } from "@coworker/app/src/components/TestBuy/CommonComponents/Repositories/testbuy.api";

const buildProductFollowUpTasks = (
  data: any,
  productId: string,
  taskId: string
) => ({
  articleId: productId,
  taskId,
  state: data.state,
  finishedAt: data.finished_at,
});

export const useGetTestbuyFollowUpTask = (taskId: string) => {
  const { data, isLoading } = useGetTaskByIdAndType(
    taskId,
    TaskType.TESTBUY_FOLLOW_UP
  );

  if (data) {
    const mappedTask = buildProductFollowUpTasks(
      data,
      data.product_article_id,
      data.id
    ) as TaskData;

    return {
      isLoading,
      data: mappedTask,
    };
  }
  return {
    isLoading,
    data: undefined,
  };
};
